/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChangeRequestMerged({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#ChangeRequestMerged_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M4.1 6.03a2.601 2.601 0 1 0-1.2 0v8.47a.6.6 0 1 0 1.2 0v-4.204A6.592 6.592 0 0 0 9.5 13.1h.47a2.601 2.601 0 1 0 0-1.2H9.5a5.4 5.4 0 0 1-5.4-5.4v-.47Zm-2-2.53a1.4 1.4 0 1 0 2.8 0 1.4 1.4 0 0 0-2.8 0Zm10.4 10.4a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8Z" clipRule="evenodd" /></g><defs><clipPath id="ChangeRequestMerged_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;